module.exports = __webpack_public_path__ + "static/img/cadastro_recusado.a89ce9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cadastro_recusado.png
// module id = UWyX
// module chunks = 1